import {
  signIn,
  signOut,
  getCurrentUser as amplifyGetCurrentUser,
} from "aws-amplify/auth";

export async function login(email, password) {
  await signIn({ username: email, password }).catch((e) =>
    console.log("Error: ", e)
  );
}

export async function logout() {
  try {
    // clear local user session

    await signOut();
  } catch (error) {
    console.log("error signing out: ", error);
  }
}

export function getCurrentUser() {
  try {
    const cookies = document.cookie.split(";").map((c) => c.trim());
    const now = Date.now() / 1000;

    const accessTokenCookie = cookies.find(
      (c) =>
        c.startsWith("CognitoIdentityServiceProvider") &&
        c.includes(".accessToken=")
    );
    const idTokenCookie = cookies.find(
      (c) =>
        c.startsWith("CognitoIdentityServiceProvider") &&
        c.includes(".idToken=")
    );

    if (!accessTokenCookie || !idTokenCookie) return false;

    // Decode JWT payloads to check expiration
    const accessToken = accessTokenCookie.split("=").slice(1).join("=");
    const idToken = idTokenCookie.split("=").slice(1).join("=");
    const accessExp = JSON.parse(atob(accessToken.split(".")[1])).exp;
    const idExp = JSON.parse(atob(idToken.split(".")[1])).exp;

    return accessExp > now && idExp > now;
  } catch {
    return false;
  }
}

export function getTokenExpiration() {
  try {
    const cookies = document.cookie.split(";").map((c) => c.trim());
    const accessTokenCookie = cookies.find(
      (c) =>
        c.startsWith("CognitoIdentityServiceProvider") &&
        c.includes(".accessToken=")
    );
    if (!accessTokenCookie) return null;
    const accessToken = accessTokenCookie.split("=").slice(1).join("=");
    const payload = JSON.parse(atob(accessToken.split(".")[1]));
    return payload.exp; // Unix timestamp in seconds
  } catch {
    return null;
  }
}

export async function getUserName() {
  try {
    // First try to get from Amplify (works in dev with Cognito)
    const cognitoUser = await amplifyGetCurrentUser();
    if (cognitoUser?.username) {
      return cognitoUser.username;
    }
  } catch (error) {
    console.log(
      "Amplify getCurrentUser failed, trying cookie fallback:",
      error
    );
  }

  // Fallback: Extract username from cookies (production SSO)
  try {
    const cookies = document.cookie;
    const cookieArray = cookies.split("; ");

    for (let cookie of cookieArray) {
      const [name, value] = cookie.split("=");
      // Look for common username patterns in SSO cookies
      if (
        name &&
        (name.toLowerCase().includes("user") ||
          name.toLowerCase().includes("email") ||
          name.toLowerCase().includes("name"))
      ) {
        const decodedValue = decodeURIComponent(value);
        if (decodedValue && decodedValue !== "") {
          return decodedValue;
        }
      }
    }
  } catch (cookieError) {
    console.log("Cookie fallback failed:", cookieError);
  }

  return "";
}

const services = {
  login,
  logout,
  getCurrentUser,
  getTokenExpiration,
  getUserName,
};
export default services;
